<template>
    <div id="wrap" class="animsition">
        <loader v-if="loader == true"></loader>
        <section id="content" style="top: 0px!important;">
            <div id="pagelogin">

                <div class="page page-core page-login">
                  
                   
                    <div class="container w-420 p-15 bg-white mt-40 border-radius-sc" >
                    <img class="png-logo" src="https://sicoobcrediauc-agricredit.softfocus.com.br/public/images/logo/sicoobcrediauc_logo_login.png" alt="Sicoob Crediauc">
                    <span class="crediauc-span">Crediauc</span>

                        <div class="row form-group">
                            <div class="col-md-12">
                                <h2 style="color:#fff" class="text-light text-greensea text-center">SICOOB AUTO <img src="https://img.icons8.com/?size=100&id=62662&format=png&color=FFFFFF" width="40px"></h2>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-12">
                                <label style="color: #fff;">Usuário</label>
                                <input type="text"
                                       id="user"
                                       name="usuario"
                                       @keyup.enter="auth()"
                                       class="form-control"
                                       placeholder="Usuário"
                                       autocomplete="off"
                                       required
                                       v-model="user">
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-12">
                                <label style="color: #fff;">Senha</label>
                                <input type="password"
                                       name="password"
                                       @keyup.enter="auth()"
                                       id="pwd"
                                       placeholder="Senha"
                                       class="form-control"
                                       autocomplete="off"
                                       required
                                       v-model="pwd">
                            </div>
                        </div>
                        <div class="row form-group">
                            <br>
                            <div class="col-md-12">
                                <button class="btn btn-success btn-border btn-rounded-20 btn-ef btn-ef-4 btn-ef-4a mb-10 btn-lg"
                                        @click="auth()"
                                        id="login"
                                        :disabled="user == '' || pwd == ''">
                                    Acessar <i class="fa fa-arrow-right"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="form-group text-left mt-20"><br>
                        <p style="font-size: 20px; text-align: center; color: #fff"> <b>SICOOB AUTO / MOTOCICLETA </b></p>
                    </div>
                </div>
            </div>
        </section>
        <div class="modal fade" id="novaSenha" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="display: none; margin-top: 80px;">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header" style="background-color: #78b800!important; color: #fff!important;">
                        <h4 class="modal-title custom-font">Nova Senha</h4>
                    </div>
                    <div class="modal-body" id="conteudoDetalhes" style="max-height: calc(90vh - 210px);overflow-y: auto;">
                        <div class="row form-group">
                            <div class="col-md-12">
                                <label>Digite a Nova Senha</label>
                                <input type="password"
                                       name="password"
                                       id="nova_senha"
                                       placeholder="Nova Senha"
                                       class="form-control"
                                       autocomplete="off"
                                       required
                                       v-model="novaSenha">
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-12">
                                <label>Redigite a Nova Senha</label>
                                <input type="password"
                                       name="password"
                                       id="redigite_senha"
                                       placeholder="Redigite Nova Senha"
                                       class="form-control"
                                       autocomplete="off"
                                       required
                                       v-model="redigiteSenha">
                            </div>
                        </div>
                        <div class="row" v-if="redigiteSenha != '' && novaSenha != '' && redigiteSenha != novaSenha">
                            <div class="col-md-12">
                                <div class="alert alert-danger">
                                    <p><strong>Atenção</strong> Senhas digitadas não conferem.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                    <div class="modal-footer">
                        <div class="row">
                            <div class="col-md-12 text-left">
                                <button class="btn btn-success btn-ef btn-ef-4 btn-ef-4c"
                                        @click="save()"
                                        id="savePwd"
                                        :disabled="redigiteSenha == '' || novaSenha == '' || redigiteSenha != novaSenha">
                                    Salvar senha <i class="fa fa-arrow-right"></i>
                                </button>
                                <button class="btn btn-lightred btn-ef btn-ef-4 btn-ef-4c" data-dismiss="modal"><i class="fa fa-arrow-left"></i> Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default{
    name: 'index-login',
    data(){
        return{
            user: '',
            pwd: '',
            loader: false,
            redigiteSenha: '',
            novaSenha: ''
        }
    },
    methods: {

        save: function () {
            var form = {};
            var $this = this;

            form.password = $this.novaSenha;
            form.username = $this.user;
            $this.loader = true;
            $('#novaSenha').modal('hide');

            $this.$http.post('/login/updatelogin', form)
            .then(function (response) {
                $this.loader = false;
                $this.pwd = form.password;
                $this.redigiteSenha = '';
                $this.novaSenha ='';
                $('#novaSenha').modal('hide');
                $this.$toastr('success', 'Senha alterada com sucesso!');
            })
            .catch(function (error) {
                $this.loader = false;
                $('#novaSenha').modal('show');
            })
        },

        auth: function () {
            this.loader = true;
            var $this = this;
            var form = {};

            form.username = this.user;
            form.password = this.pwd;

            $this.$http.post('/login', form)
            .then(function (response) {
                localStorage.setItem('token', response.data.token)
                localStorage.setItem('username', response.data.user.razao_social)
                localStorage.setItem('retorno', response.data.user.retorno)
                localStorage.setItem('seguro', response.data.user.seguro)
                localStorage.setItem('feirao', response.data.user.feirao)
                $this.$toastr('success', 'Usuário logado com sucesso.', 'Atenção!')
                $this.$router.push({path: '/'})
                $this.loader = false;
            })
            .catch(function (error) {
                $this.loader = false;
                if(error.response.data.pwd) {
                    $this.redigiteSenha = '';
                    $this.novaSenha ='';
                    $('#novaSenha').modal('show');
                }
            });
        }
    }
}
</script>
<style>
    .png-logo {
        width: 19vh;
        margin-top: -18vh;
        margin-left: 25%;

    }

    .crediauc-span {
        font-size: 17px;
        color: #41988d;
        margin-left: 49%;
        position: relative;
        top: -8.5vh;
    }

    #pagelogin .confirm {
        display: none!important;
    }

    #pagelogin .nav-link {
        cursor:pointer;
    }

    #pagelogin  .router-link-exact-active{
        background: #78b800!important;
        color: #fff!important;
    }

    #pagelogin  #header .dropdown > .dropdown-menu {
        margin-top: -2px;
        margin-left: -70px!important;
    }

    #pagelogin .tile {
        border-radius: 0px;
        border-top: 3px solid #78b800;
        /*color: #78b800!important;*/
    }

    #pagelogin .fonts-custom-painel h1, h2, h3, h4, h5, h6 {
        margin-top: 0px!important;
        margin-bottom: 5px;
    }

    #pagelogin  .myIcon.icon-success::after, .myIcon.icon-success.hover-color:hover, .myIcon.icon-success.icon-color {
        color: #78b800!important;
    }


    #pagelogin   .text-success {
        color: #78b800!important;
    }

    #pagelogin   #navigation > li.active > a, #navigation > li > a:hover {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
    }

    #pagelogin   .form-control {
        border-radius: 10px!important;
        font-weight: 400!important;
        font-size: 16px!important;
        color: #556080!important;
        letter-spacing: .5px!important;
        padding-top: 7.5px!important;

    }

    #pagelogin  .select2-selection--single {
        height: 40px!important;
        border: 1px solid #d2d3d5!important;
        padding-top: 5px!important;
        color: #556080!important;
    }

    #pagelogin  .select2-selection__arrow {
        top: 5px!important;
    }

    #pagelogin  #header .dropdown > .dropdown-menu {
        border-radius: 10px!important;
    }

    #pagelogin   .btn {
        border-radius: 0px!important;
        height: 40px!important;
    }

    #pagelogin  .btn-default {
        color: #333!important;
        background-color: #fff!important;
        border-color: #ccc!important;
        padding-top: 9px!important;
    }

    #pagelogin  .btn-default:hover, .btn-default:focus, .btn-default:active{
        color: #333!important;
        background-color: #f0f0f0!important;
        border-color: #ccc!important;
        padding-top: 9px!important;
    }

    #pagelogin  .form-control:focus {
        border:1px solid #a9abae!important;
    }

    #pagelogin   #navigation{
        margin-left: -32px!important;
    }

    @media  screen and (max-width: 748px) {
        #pagelogin     #navigation{
            margin-left: -10px!important;
        }
    }

    #pagelogin   .page-core {
        background-color: #FFF!important;
    }

    #pagelogin .border-radius-sc {
        border-radius: 10px!important;
    }

    #pagelogin   .swal2-popup .swal2-styled {

        background: #78b800!important;
    }

    #pagelogin   a{
        color: #FFF!important;
    }

    #pagelogin    .appWrapper.header-fixed.sidebar-xs #content {
        left: 0px!important;
    }

    #pagelogin    .appWrapper.header-fixed.sidebar-sm #content {
        left: 40px!important;
    }

    #pagelogin   .swal2-popup .swal2-image {
        width: 15%!important;
    }

    #pagelogin  .swal2-popup .swal2-title {
        color: #a9abae!important;
    }


    @media  only screen and (max-width: 768px) {
        #pagelogin .appWrapper.header-fixed.aside-fixed #content {
            top: 15px!important;
        }
    }

</style>



// WEBPACK FOOTER //
// src/views/login/Index.vue